"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ics = exports.eventify = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(utc_1.default);
const TimeFormats = {
    dateTimeWithOffset: 'YYYY-MM-DD[T]HH:mm:ssZ',
    dateTimeUTC: 'YYYYMMDD[T]HHmmss[Z]',
    allDay: 'YYYYMMDD',
};
function formatTimes({ allDay, startUtc, endUtc }, dateTimeFormat) {
    const format = TimeFormats[allDay ? 'allDay' : dateTimeFormat];
    return { start: startUtc.format(format), end: endUtc.format(format) };
}
const eventify = (event) => {
    const { start, end, duration } = event, rest = __rest(event, ["start", "end", "duration"]);
    const startUtc = (0, dayjs_1.default)(start).utc();
    const endUtc = end
        ? (0, dayjs_1.default)(end).utc()
        : (() => {
            if (event.allDay) {
                return startUtc.add(1, 'day');
            }
            if (duration && duration.length === 2) {
                const value = Number(duration[0]);
                const unit = duration[1];
                return startUtc.add(value, unit);
            }
            return (0, dayjs_1.default)().utc();
        })();
    return Object.assign(Object.assign({}, rest), { startUtc,
        endUtc });
};
exports.eventify = eventify;
const ics = (calendarEvent) => {
    const event = (0, exports.eventify)(calendarEvent);
    const formattedDescription = (event.description || '')
        .replace(/,/gm, ',')
        .replace(/;/gm, ';')
        .replace(/\n/gm, '\\n')
        .replace(/(\\n)[\s\t]+/gm, '\\n');
    const formattedLocation = (event.location || '')
        .replace(/,/gm, ',')
        .replace(/;/gm, ';')
        .replace(/\n/gm, '\\n')
        .replace(/(\\n)[\s\t]+/gm, '\\n');
    const { start, end } = formatTimes(event, 'dateTimeUTC');
    const calendarChunks = [
        {
            key: 'BEGIN',
            value: 'VCALENDAR',
        },
        {
            key: 'VERSION',
            value: '2.0',
        },
        {
            key: 'BEGIN',
            value: 'VEVENT',
        },
        {
            key: 'URL',
            value: event.url,
        },
        {
            key: 'DTSTART',
            value: start,
        },
        {
            key: 'DTEND',
            value: end,
        },
        {
            key: 'SUMMARY',
            value: event.title,
        },
        {
            key: 'DESCRIPTION',
            value: formattedDescription,
        },
        {
            key: 'LOCATION',
            value: formattedLocation,
        },
        {
            key: 'END',
            value: 'VEVENT',
        },
        {
            key: 'END',
            value: 'VCALENDAR',
        },
    ];
    let calendarUrl = '';
    calendarChunks.forEach(chunk => {
        if (chunk.value) {
            calendarUrl += `${chunk.key}:${encodeURIComponent(`${chunk.value}\n`)}`;
        }
    });
    return `data:text/calendar;charset=utf8,${calendarUrl}`;
};
exports.ics = ics;
